import React from 'react';
import i18next from 'i18next';
import ChatMessage from './ChatMessage/ChatMessage';
import ChatReply from './ChatReply/ChatReply';
import { connect } from 'react-redux';
import {
  chatWs,
  STATUS_CONNECTED,
  STATUS_DISCONNECTED,
} from '../../websocketController';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';

class Chat extends React.PureComponent {
  constructor(props) {
    super(props);

    this.chatScroll = React.createRef();
    this.replyRef = React.createRef();
    this.timer = null;
    this.scrollTimer = null;

    this.state = {
      wsStatus: STATUS_DISCONNECTED,
      replyTo: false,
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      if (chatWs.status !== this.state.wsStatus) {
        this.setState({ wsStatus: chatWs.status });
      }
    }, 1000);

    if (this.props.messages.length) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimer);
    clearInterval(this.timer);
  }

  componentDidUpdate(prevProps) {
    const threshold = 300;
    const scroll = this.chatScroll.current;

    if (scroll) {
      if (this.props.loaded && !prevProps.loaded) {
        this.scrollToBottom();
      }

      if (
        scroll.getScrollHeight() -
          (scroll.getScrollTop() + scroll.getClientHeight()) <
        threshold
      ) {
        this.scrollToBottom();
      }
    }
  }

  onSend = (message) => {
    chatWs.send(JSON.stringify({ action: 'chat', message }));
    this.cleanReply();
  };

  onReply = (username) => {
    if (this.props.userId) {
      this.setState({
        replyTo: username,
      });

      this.replyRef.current.focus();
    }
  };

  cleanReply = () => {
    this.setState({
      replyTo: false,
    });
  };

  scrollToBottom = () => {
    this.scrollTimer = setTimeout(() => {
      const scroll = this.chatScroll.current;
      if (scroll) {
        scroll.scrollToBottom();
      }
    }, 100);
  };

  render() {
    const { messages, userId, loaded } = this.props;
    const chatClasses = classNames('chat', { 'chat--with-reply': !!userId });

    return (
      <div className={chatClasses}>
        <span className="chat__title">
          <span>
            {i18next.t('chat.title')}
            <span
              className={classNames(
                'status',
                this.state.wsStatus === STATUS_CONNECTED ? 'online' : 'offline'
              )}
            />
          </span>
        </span>
        <Scrollbars
          ref={this.chatScroll}
          style={{ height: '100%' }}
          hideTracksWhenNotNeeded={true}
        >
          <div className="chat__messages">
            {loaded &&
              messages.map((item, i) => (
                <ChatMessage
                  onReply={this.onReply}
                  message={item}
                  key={i}
                  isMine={userId && item.user_id === userId}
                  renderReply={!!userId}
                />
              ))}
          </div>
        </Scrollbars>
        {this.props.userId && (
          <div className="chat__reply" key="reply">
            <ChatReply
              onSend={this.onSend}
              disabled={!userId || this.state.wsStatus !== STATUS_CONNECTED}
              replyTo={this.state.replyTo}
              cleanReply={this.cleanReply}
              replyRef={this.replyRef}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    userId: state.user.profile ? state.user.profile.user_id : false,
    loaded: !state.user.isLoading,
    messages: state.chat.messages,
  };
}, {})(Chat);



// WEBPACK FOOTER //
// ./app/components/Chat/Chat.jsx